import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DisputesService } from 'app/main/services/disputes.service';
import { SalesPackageService } from 'app/main/services/salespackage.service';
import { SoftskillService } from 'app/main/services/softskill.service';
import { SoftskillCategoryService } from 'app/main/services/softskillCategory.service';
import { UtilsService } from 'app/main/services/utils.service';
import { AlertComponentComponent } from 'app/main/shared/alert/alert-component/alert-component.component';
import {
    Dispute,
    DisputeComponent
} from 'app/main/shared/components/dispute/dispute.component';
import { ProfessorCategoryLegendComponent } from 'app/main/shared/components/professor-categories-legend/professor-categories-legend.component';
import { LoaderService } from 'app/main/shared/services/loaderService.service';
import { LocalAccountService } from 'app/main/shared/services/localAccount.service';
import { AppUtils } from 'app/main/utils/appUtils';

type ProfessorEstimationComponentMode =
    "CREATE" | "VIEW";

@Component({
    selector: 'app-estimation',
    templateUrl: './estimation.component.html',
    styleUrls: ['./estimation.component.scss']
})
export class EstimationComponent implements OnInit {
    salespackagesAllowed: any[];
    categoriesAllowed: any[]
    softskillsAllowed: any[];
    message: string;
    inputData: any;
    isModal: boolean;
    title: any;
    mode: ProfessorEstimationComponentMode;
    categorySelected: any;
    softskillSelected: any;
    salesPackageSelected: any;
    categorySelectedId: any;
    softskillSelectedId: any;
    salesPackageSelectedId: any;
    hourlyCostToUse: any;
    maxNumStudentsToUse: any;
    isStudent: any;
    isAdmin: any;
    showPayButton: boolean;
    showCreateEstimationButton: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EstimationComponent>,
        private softskillCategoryService: SoftskillCategoryService,
        private softskillService: SoftskillService,
        private salespackageService: SalesPackageService,
        private loaderService: LoaderService,
        private utilsService: UtilsService,
        private dialog: MatDialog,
        private disputesService: DisputesService,
        private localAccountService: LocalAccountService,

    ) {
        this.message = '';
        this.inputData = data;
        this.isModal = true;
    }


    async ngOnInit() {
        this.mode = this.inputData.mode;
        await this.init();
    }

    async init() {
        this.loaderService.showLoader();
        try {
            if (this.mode === 'CREATE') {
                this.title = 'Creazione del Preventivo';
                this.hourlyCostToUse = this.inputData.user.hourlyCostToUse;
                this.maxNumStudentsToUse = this.inputData.user.maxNumStudentsToUse;
            } else if (this.mode === 'VIEW') {
                this.title = 'Visualizzazione del Preventivo';
                this.hourlyCostToUse = this.inputData.purchasedSalesPackage.hourlyCostToUse;
                this.maxNumStudentsToUse = this.inputData.purchasedSalesPackage.maxNumStudentsToUse;
            }
            this.isStudent = this.inputData.user.ruolo === 'STUDENT';
            this.isAdmin = this.inputData.user.ruolo === 'ADMINISTRATOR';
            this.showPayButton = this.isStudent && this.mode === 'VIEW' && this.inputData.purchasedSalesPackage.lastEvent && this.inputData.purchasedSalesPackage.lastEvent.eventName ===
                'WAITING_FOR_PAYMENT' ||
                (this.inputData.purchasedSalesPackage.lastEvent.eventName ===
                    'STUDENT_ATTEMPT_TO_PAY' && (this.inputData.purchasedSalesPackage.paymentType === 'PAYPAL' || !this.inputData.purchasedSalesPackage.bankTransferIban)) ||
                (this.inputData.purchasedSalesPackage.lastEvent.eventName ===
                    'ERROR' &&
                    (
                        this.inputData.purchasedSalesPackage.lastEvent.prevEventName === 'STUDENT_ATTEMPT_TO_PAY' ||
                        this.inputData.purchasedSalesPackage.lastEvent.prevEventName === 'WAITING_FOR_PAYMENT'
                    )
                );
            this.showCreateEstimationButton = !this.isStudent && !this.isAdmin && this.inputData.purchasedSalesPackage.lastEvent
                && (this.inputData.purchasedSalesPackage.lastEvent.eventName === 'ESTIMATING'
                    || this.inputData.purchasedSalesPackage.lastEvent.eventName === 'WAITING_FOR_PAYMENT');
            this.salesPackageSelected = this.inputData.purchasedSalesPackage.salesPackage ? this.inputData.purchasedSalesPackage.salesPackage : null;
            let softskillSelected;
            if (this.salesPackageSelected) {
                this.salesPackageSelectedId = this.salesPackageSelected.id;
                softskillSelected = this.salesPackageSelected.frontEndSoftskillFacade;
            } else {
                softskillSelected = this.inputData.purchasedSalesPackage.lastProposal.softskill;
            }
            this.softskillSelected = softskillSelected;
            this.softskillSelectedId = this.softskillSelected.id;
            this.categorySelected = this.softskillSelected.frontEndSoftskillCategoryFacade;
            this.categorySelectedId = this.categorySelected.id;
            await this.getSoftskillCategoriesForEstimation();
            await this.getSoftskillsForEstimation();
            await this.getSalespackagesForEstimation();
        } finally {
            this.loaderService.hideLoader();
        }
    }

    async getSoftskill(category) {
        this.loaderService.showLoader();
        this.salesPackageSelected = null;
        this.categorySelected = category;
        this.categorySelectedId = category.id;
        try {
            await this.getSoftskillsForEstimation();
        } finally {
            this.loaderService.hideLoader();
        }
    }

    async getSoftskillsForEstimation() {
        this.softskillsAllowed = [];
        let resp: any;
        if (this.mode === 'CREATE') {
            resp = await this.softskillService
                .getSoftskillsForEstimation(this.categorySelectedId)
                .catch(err => {
                    console.error(err);
                });
        } else {
            resp = await this.softskillService.getAllowedSoftskillsByCategoryId(this.categorySelectedId);
        }
        if (resp) {
            if (resp.ok) {
                this.softskillsAllowed = resp.payload;
                if (this.softskillsAllowed.length > 0) {
                    this.message = '';
                } else {
                    this.message =
                        'Non sono disponibili softskill per la category selezionata';
                }
            }
        }
    }

    async getSoftskillCategoriesForEstimation() {
        let resp: any;
        if (this.mode === 'CREATE') {
            resp = await this.softskillCategoryService
                .getSoftskillCategoriesForEstimation()
                .catch(err => {
                    console.error(err);
                });
        } else {
            resp = await this.softskillCategoryService.getAllowedSoftskillCategories();
        }
        if (resp) {
            if (resp.ok) {
                this.categoriesAllowed = resp.payload;
                if (this.categoriesAllowed.length > 0) {
                    this.message = '';
                } else {
                    this.message = 'Non sono disponibili categorie';
                }
            }
        }
    }

    async getSalespackage(softskill) {
        this.loaderService.showLoader();
        this.salesPackageSelected = null;
        this.softskillSelected = softskill;
        this.softskillSelectedId = softskill.id;
        try {
            await this.getSalespackagesForEstimation();
        } finally {
            this.loaderService.hideLoader();
        }
    }

    async getSalespackagesForEstimation() {
        this.salespackagesAllowed = [];
        let resp: any;
        if (this.mode === 'CREATE') {
            resp = await this.salespackageService
                .getSalespackagesForEstimation(this.softskillSelectedId)
                .catch(err => {
                    console.error(err);
                });
        } else {
            resp = await this.salespackageService.getAllowedSalespackageBySoftskill(this.softskillSelectedId);
        }
        if (resp.ok) {
            this.salespackagesAllowed = resp.payload;
            if (this.salespackagesAllowed.length > 0) {
                if (!this.salesPackageSelected) {
                    this.salesPackageSelected = this.salespackagesAllowed[0];
                    this.message = '';
                }
            } else {
                this.message =
                    'Non sono disponibili pacchetti di vendita per la softskill selezionata';
            }
        }
    }

    async richiediCorso() {
        const dispute = new Dispute();
        dispute.genericOptionType = 'COURSE_NOT_PRESENT';
        dispute.type = 'GENERIC';
        const dialog = this.dialog.open(DisputeComponent, {
            width: '400px',
            panelClass: 'custom-panel-class',
            data: {
                fromPage: 'newCourse',
                dispute: dispute,
                closeModal: async (data?) => {
                    if (data) {
                        const obj: any = data;
                        this.loaderService.showLoader();
                        const res: any = await this.disputesService
                            .newDispute(obj)
                            .catch(err => {
                                console.error(err);
                            })
                            .finally(() => {
                                this.loaderService.hideLoader();
                            });
                        if (res) {
                            if (res.ok) {
                                dialog.close();
                                this.utilsService.newSuccessSnackbar(
                                    `Richiesta creata con successo.`
                                );
                            }
                        }
                    } else {
                        dialog.close();
                    }
                }
            }
        });
    }

    onSelectedSalesPackage(salesPackageSelected) {
        if (this.mode !== 'CREATE') {
            return;
        }
        this.salesPackageSelected = salesPackageSelected;
    }

    openInfoDialog() {
        const dialog = this.dialog.open(ProfessorCategoryLegendComponent, {
            width: '400px',
            maxHeight: '90vh',
            panelClass: 'custom-panel-class',
            data: {

            }
        });
    }

    retrieveTotal(valToBeRounded) {
        return AppUtils.roundAndRenderToTwoDecimals(valToBeRounded);
    }

    pay() {
        const confirmDialog = this.dialog.open(
            AlertComponentComponent,
            {
                width: '400px',
                maxHeight: '80vh',
                data: {
                    innerHTML: true,
                    body:
                        'Se confermi, avvierai la procedura di pagamento e questa schermata si chiudera\' (potrai riconsultarla sempre). Vuoi procedere?',
                    buttons: [
                        {
                            text: 'Annulla',
                            color: 'default',
                            close: true,
                            value: false,
                            callback: async () => {
                                confirmDialog.close();
                            }
                        },
                        {
                            text: 'Conferma',
                            color: 'primary',
                            close: false,
                            value: true,
                            callback: () => {
                                confirmDialog.close();
                                this.inputData.okCallback();
                            }
                        }
                    ]
                }
            }
        );
    }

    save() {
        const confirmDialog = this.dialog.open(
            AlertComponentComponent,
            {
                width: '400px',
                maxHeight: '80vh',
                data: {
                    innerHTML: true,
                    body:
                        'Se confermi, il discente ricevera\' il preventivo e potra\' acquistarlo. Sei sicuro di voler procedere?',
                    buttons: [
                        {
                            text: 'Annulla',
                            color: 'default',
                            close: true,
                            value: false,
                            callback: async () => {
                                confirmDialog.close();
                            }
                        },
                        {
                            text: 'Conferma',
                            color: 'primary',
                            close: false,
                            value: true,
                            callback: data => {
                                confirmDialog.close();
                                let obj: any = {};
                                obj.salesPackageId = this.salesPackageSelected.id;
                                obj.duration = this.salesPackageSelected.duration;
                                obj.hourlyCostToUse = this.data.user.hourlyCostToUse;
                                obj.maxNumStudentsToUse = this.data.user.maxNumStudentsToUse;
                                obj.total = AppUtils.roundAndRenderToTwoDecimals(obj.duration * obj.hourlyCostToUse);
                                this.inputData.okCallback(obj);
                            }
                        }
                    ]
                }
            }
        );
    }

    createEstimation() {
        this.inputData.createEstimationCallback();
    }
}
